// 유틸 함수: 코치 이름에서 " Coach", " 외 n명" 등의 접미사 제거
export const cleanTeacherName = (name) => {
  return typeof name === 'string' ?
    name.replace(/ 외 \d+명$/, '').replace(/ Coach$/, '').trim()
    :
    name;
};

// teacherIds(콤마 문자열) 기준으로 코치를 해석한다 //
// 코치 이름은 매장명 변경 등으로 바뀌지만 ID는 불변이므로 ID를 우선 사용하고,
// 삭제된 코치라 ID로 못 찾을 때만 같은 자리의 이름 스냅샷으로 폴백한다.
export const resolveTeachers = (teacherIds, snapshotNames, teachersById, teachersByName) => {
  const ids = typeof teacherIds === 'string' ? teacherIds.split(',').map(id => id.trim()).filter(id => id !== '') : [];
  const names = snapshotNames || [];
  const resolved = [];

  for (let i = 0; i < ids.length; i++) {
    const teacher = teachersById.get(ids[i]);

    if (teacher) {
      resolved.push({ name: teacher.name, profile: teacher.profile || '' });
      continue;
    }

    // ID로 못 찾은 경우 (코치 삭제 후 동명 재등록 등) 이름 스냅샷으로 폴백 //
    const snapshotName = names[i];

    if (!snapshotName) continue;

    const fallbackTeacher = teachersByName.get(snapshotName);

    resolved.push({ name: snapshotName, profile: fallbackTeacher?.profile || '' });
  }

  return resolved;
};
